var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoInstagraminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.291,
    height: 28.29
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "co-instagram_inline_svg__defs452"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style450"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-600.581 -3375.995)",
    id: "co-instagram_inline_svg__g460",
    fill: "#26317a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.713 3383.45h-7.261a3.18 3.18 0 00-3.137 3.222v7.549a3.182 3.182 0 003.137 3.224h7.261a3.182 3.182 0 003.137-3.224v-7.549a3.18 3.18 0 00-3.137-3.222zm-3.626 11.51a4.441 4.441 0 114.321-4.438 4.381 4.381 0 01-4.321 4.438zm4.5-8.052a1.054 1.054 0 111.025-1.052 1.039 1.039 0 01-1.022 1.052z",
    id: "co-instagram_inline_svg__path454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.106 3376a14.145 14.145 0 1013.765 14.138A13.973 13.973 0 00615.106 3376zm8.271 18.276a4.684 4.684 0 01-4.619 4.746h-7.351a4.685 4.685 0 01-4.621-4.746v-7.662a4.684 4.684 0 014.621-4.745h7.351a4.683 4.683 0 014.619 4.745z",
    id: "co-instagram_inline_svg__path456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.087 3387.652a2.871 2.871 0 102.8 2.87 2.833 2.833 0 00-2.8-2.87z",
    id: "co-instagram_inline_svg__path458"
  }))));
}

export default SvgCoInstagraminline;